import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import LoginForm from '../containers/Login/LoginForm'
import TextWithLink from './TextWithLink'

import { initPageView } from '../../Analytics/common'

const Login = () => {
  useEffect(() => {
    initPageView()
  }, [])
  return (
    <section className='account-form-wrapper'>
      <div className='title'>Customer sign in</div>
      <LoginForm />
      <TextWithLink
        text='New customer?'
        linkTest='Register'
        link='/signup'
      />
      <hr />
      <div className='forgot-password'>
        <Link to='/forgotpassword' className='forgot-password-btn'> Forgot password? </Link>
      </div>
    </section>
  )
}

export default Login
